import React from 'react';
import { Box } from '@mui/material';

interface StatsContainerProps {
  children: React.ReactNode;
  sx?: any;
}

const StatsContainer: React.FC<StatsContainerProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        gap: '16px',
        margin: '20px 0',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default StatsContainer;

